module.exports = __webpack_public_path__ + "static/media/blog-3.ece7f4d1.jpg";